<template>
    <v-card>
        <ImageCard :refId="plant" type="plant"></ImageCard>
            <v-card-title>
                {{plant.name}}
                <span class="map-marker"><v-avatar :color="plant.color" size="14" tile></v-avatar></span>
            </v-card-title>
            <v-card-subtitle class="font-italic">{{plant.scientificName}}</v-card-subtitle>
        <v-card-text class="red--text font-weight-medium" v-if="plant.riskLevel=='critical'">
            <v-icon color="red">mdi-alert</v-icon>Achtung, gesundheitsgefährdend!
            <!--v-chip v-for="(item, idx) in plant.mixUps" :key="idx">{{item}}</v-chip-->
        </v-card-text>
        <v-card-text class="orange--text font-weight-medium" v-else-if="plant.riskLevel=='warning'">
            <v-icon color="orange">mdi-alert</v-icon>Vorsicht bei Pflanzenkontakt!
            <!--v-chip v-for="(item, idx) in plant.mixUps" :key="idx">{{item}}</v-chip-->
        </v-card-text>
        <v-card-text style="visibility: hidden" class="font-weight-medium" v-else>
            dummy
            <!--v-chip v-for="(item, idx) in plant.mixUps" :key="idx">{{item}}</v-chip-->
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text icon color="green" :to="{name: 'Plant', params: {plantId: plant.uuid}}" v-if="!authorized">
                <v-icon>mdi-eye</v-icon>
            </v-btn>
            <v-btn text icon color="green" :to="{name: 'Plant', params: {plantId: plant.uuid}}" v-if="authorized">
                <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn text icon color="red" @click="onDelete(plant.uuid)" v-if="authorized">
                <v-icon>mdi-delete</v-icon>
            </v-btn>
            <ConfirmDialog ref="confirm"></ConfirmDialog>
        </v-card-actions>
    </v-card>
</template>

<script>
    import {Roles} from '../../_helpers';
    import ImageCard from '../../base/ImageCard'
    import ConfirmDialog from '../../base/ConfirmDialog';

    export default {
        name: 'PlantCard',
        props: ['plant'],
        components: {
            ConfirmDialog,
            ImageCard
        },
        computed: {
            imageId() {
                return (this.plant.imageIds && this.plant.imageIds.length > 0) ? this.plant.imageIds[0] : null
            },
            authorized() {
                let userProfile = this.$store.getters.userProfile

                // Only an authenticated user with SUPERADMIN role is allowed to manage plants
                return this.$store.getters.isAuthenticated && userProfile
                    && (userProfile.role === Roles.ROLE_1.value || userProfile.role === Roles.ROLE_2.value)
            }
        },
        methods: {
            onDelete(plantId) {
                // Open confirmation dialog
                this.$refs.confirm.open(
                    this.$t('key.deletePlantTitle'),
                    this.$t('key.deletePlantText', {'0': this.plant.name}), { color: 'red' })
                    .then((confirm) => {
                        if (confirm) {
                            this.$store.dispatch('deletePlant', plantId)
                        }
                    })
            }
        }
    }
</script>

<style lang="scss">
    .v-card {
        .v-card__title {
            span {
                padding-left: 10px;
            }
        }

        .v-card__text {
            ul {
                margin-bottom: 15px;
            }

            .v-chip {
                margin-top: 5px;
                margin-right: 5px;
            }
        }
    }
</style>
